import SeasonIllustrationBackground from '@/components/SeasonIllustrationBackground/SeasonIllustrationBackground';
import Video from '@/components/Video/Video';
import VideoPlayer from '@/components/Video/VideoPlayer';
import useAchievements from '@/hooks/useAchievements';
import useCollectionCompleteVideo from '@/hooks/useCollectionCompleteVideo';
import { Dialog, DialogPanel } from '@headlessui/react';
import { FC, useMemo, useState } from 'react';

const CollectionCompleteVideo: FC = () => {
	const { achievements } = useAchievements();

	const {
		collectionCompleteVideo,
		hasSeenCollectionCompleteVideo,
		setHasSeenCollectionCompleteVideo,
		isError,
	} = useCollectionCompleteVideo();

	const shouldShowCollectionCompleteVideo = useMemo(
		() =>
			achievements.some(
				(achievement) =>
					achievement.id === 'collection-complete' &&
					achievement.calculatedTotalScore > 0,
			),
		[achievements],
	);

	const [isPlaying, setIsPlaying] = useState(false);
	const [isLessThanTwoSecondsLeft, setIsLessThanTwoSecondsLeft] =
		useState(false);

	if (
		!shouldShowCollectionCompleteVideo ||
		!collectionCompleteVideo ||
		isError
	)
		return null;

	return (
		<>
			<Video
				video={collectionCompleteVideo.video}
				aspectRatio="portrait"
			/>
			<Dialog
				open={!hasSeenCollectionCompleteVideo}
				onClose={() => setHasSeenCollectionCompleteVideo(true)}
				className="animate-fade-in">
				<SeasonIllustrationBackground
					className={`transition-all duration-[2s] ease-in ${
						isPlaying && isLessThanTwoSecondsLeft
							? 'scale-110 opacity-0'
							: 'scale-100 opacity-100'
					}`}>
					<DialogPanel className="relative size-full">
						<div className="absolute start-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 overflow-hidden">
							<section
								aria-label="Intro video"
								className={`relative aspect-[9/16] h-[calc(100vh-2rem)] overflow-hidden bg-primary transition-all duration-[2s] xxs:portrait:h-[calc(100vh-8rem)] ${
									isPlaying
										? 'scale-95 rounded-lg'
										: 'scale-90 rounded-3xl'
								}`}>
								<VideoPlayer
									video={collectionCompleteVideo.video}
									showThumbnail
									onIsPlayingChange={setIsPlaying}
									onCurrentTimeChange={(
										currentTime,
										duration,
									) => {
										if (currentTime > duration - 2) {
											setIsLessThanTwoSecondsLeft(true);
										} else {
											setIsLessThanTwoSecondsLeft(false);
										}
									}}
									onEnded={() =>
										setHasSeenCollectionCompleteVideo(true)
									}
								/>
							</section>
						</div>
					</DialogPanel>
				</SeasonIllustrationBackground>
			</Dialog>
		</>
	);
};

export default CollectionCompleteVideo;
